export enum Junction {
  AND = 1,
  OR = 2
}
